exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  margin-top: 20px;\n  line-height: 1.5em; }\n\nli {\n  line-height: 2em;\n  list-style: none;\n  margin-top: 10px; }\n\nh5 {\n  font-weight: bolder; }\n\nh4 {\n  font-weight: bolder;\n  font-size: larger; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/error404/error404.component.scss
// module id = ../../../../../src/app/pages/error404/error404.component.scss
// module chunks = main